import { render, staticRenderFns } from "./NewVersion.vue?vue&type=template&id=6707c31e&scoped=true"
import script from "./NewVersion.vue?vue&type=script&lang=js"
export * from "./NewVersion.vue?vue&type=script&lang=js"
import style0 from "./NewVersion.vue?vue&type=style&index=0&id=6707c31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6707c31e",
  null
  
)

export default component.exports